import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    palette: {
      secondary: {
        main: '#d5d5d5',//'87d67b',
      },
      primary: {
        main: '#0074d4',//'#027000',
        faint: '#DDFFDD',
      },
      analogous: {
        main: '#003bd2',//'#7bd69c',
      },
      extra: {
        main: '#ff9500',
      }
    },
  });
  
  export default theme;